import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from './client';

const KEY = ['contacts'];

export const useContacts = ({ enabled = true } = {}) =>
  useQuery({
    queryKey: KEY,
    queryFn: () => apiFetch('/api/contacts/fetchallcontacts'),
    enabled,
  });

// Public form: rate-limited, server strips admin-only `notes` field.
export const useAddContact = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      apiFetch('/api/contacts/addingcontact', { method: 'POST', body: data }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
};

// Admin manual-add: auth-gated, accepts `notes`. Use this from /contactinfo.
export const useAdminAddContact = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      apiFetch('/api/contacts/adminadd', { method: 'POST', body: data }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
};

export const useUpdateContact = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ _id, ...data }) =>
      apiFetch(`/api/contacts/editcontact/${_id}`, { method: 'PUT', body: data }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
};

export const useDeleteContact = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) =>
      apiFetch(`/api/contacts/deletecontact/${id}`, { method: 'DELETE' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
};
